import { v4 as uuidv4 } from 'uuid';
import { formatDateLabelWithoutWeekDay } from './Utilitiy';

const parseTemplateRules = (templateRules) => {
  if (!templateRules) {
    return { shifts: [] };
  }

  if (typeof templateRules === 'string') {
    try {
      return JSON.parse(templateRules);
    } catch (error) {
      return { shifts: [] };
    }
  }

  return templateRules;
};

const parseDdMmYyyy = (value) => {
  if (!value) return null;
  const [day, month, year] = String(value).split('-').map(Number);
  if (!day || !month || !year) return null;
  return new Date(year, month - 1, day);
};

const filterBookedItemsByDateRange = (bookedItems, startDate, endDate) => {
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return [];
  }

  return (Array.isArray(bookedItems) ? bookedItems : []).filter((item) => {
    const itemDate = parseDdMmYyyy(item?.date);
    if (!itemDate || Number.isNaN(itemDate.getTime())) {
      return false;
    }

    return itemDate >= start && itemDate <= end;
  });
};

const buildManualTemplateRules = (bookedItems) => {
  const shifts = (Array.isArray(bookedItems) ? bookedItems : [])
    .filter((item) => item?.date && item?.starttime && item?.endtime)
    .map((item) => {
      const itemDate = parseDdMmYyyy(item.date);
      return {
        dayOfWeek: itemDate ? itemDate.getDay() : null,
        startTime: item.starttime,
        endTime: item.endtime,
        assignedStaffId: item.staffId || '',
        isOpenShift: item.status === 'available' || !item.staffId,
        areaName: item.areaName || '',
      };
    })
    .filter((item) => item.dayOfWeek !== null);

  return { shifts };
};

const buildManualTemplatePayload = ({
  templateName,
  companyId,
  locationId,
  bookedItems,
  startDate,
  endDate,
}) => {
  const itemsInRange = filterBookedItemsByDateRange(bookedItems, startDate, endDate);

  return {
    id: uuidv4(),
    companyId,
    locationId,
    templateName: String(templateName || '').trim(),
    type: 'manual',
    templateRules: buildManualTemplateRules(itemsInRange),
  };
};

const expandManualTemplateRules = ({ templateRules, startDate, endDate, companyId, locationId }) => {
  const parsedRules = parseTemplateRules(templateRules);
  const shifts = Array.isArray(parsedRules?.shifts) ? parsedRules.shifts : [];
  const start = new Date(startDate);
  const end = new Date(endDate);

  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
    return [];
  }

  const generatedItems = [];

  for (let cursor = new Date(start); cursor <= end; cursor.setDate(cursor.getDate() + 1)) {
    const currentDayOfWeek = cursor.getDay();
    const dayMatches = shifts.filter((shift) => Number(shift?.dayOfWeek) === currentDayOfWeek);

    for (const shift of dayMatches) {
      generatedItems.push({
        id: uuidv4(),
        date: formatDateLabelWithoutWeekDay(cursor),
        staffId: shift?.isOpenShift ? '' : shift?.assignedStaffId || '',
        starttime: shift?.startTime || '',
        endtime: shift?.endTime || '',
        companyId: companyId || '',
        locationId: locationId || '',
        areaName: shift?.areaName || '',
        status: shift?.isOpenShift ? 'available' : '',
      });
    }
  }

  return generatedItems;
};

export {
  buildManualTemplatePayload,
  expandManualTemplateRules,
  filterBookedItemsByDateRange,
  parseTemplateRules,
};